import {
  getVerificationTitleName,
  isIncomeVerificationSkipped,
  verificationSourceType
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";
import { Logo } from "../../components/Logo";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { ReverifyAttempt } from "../../../ReverifySlice/types";
import { isReverifyTabAPlaceholder } from "../../../ReverifySlice/utils";

export const VerifiedHeader = ({
  selectedReverifyAttempt,
  income
}: {
  selectedReverifyAttempt?: ReverifyAttempt;
  income: CombinedIncome;
}) => {
  const isGroupedItems = Array.isArray(selectedReverifyAttempt);
  const isVerificationSkipped = isIncomeVerificationSkipped(income);
  let logo, incomeSourceType;

  if (
    !selectedReverifyAttempt ||
    isReverifyTabAPlaceholder(selectedReverifyAttempt)
  ) {
    logo = "";
    if (
      "verified_source_type" in income &&
      income.verified_source_type !== "unknown"
    )
      incomeSourceType = income.verified_source_type;
    else if (income.sources?.length) incomeSourceType = income.sources[0].type;
    else incomeSourceType = "Unknown";
  } else if (isGroupedItems) {
    logo = "";
    incomeSourceType = selectedReverifyAttempt[0].income_source_type;
  } else {
    logo =
      (selectedReverifyAttempt.data &&
        "institution_metadata" in selectedReverifyAttempt.data &&
        selectedReverifyAttempt.data.institution_metadata?.logo) ||
      "";
    incomeSourceType = selectedReverifyAttempt.income_source_type;
  }

  return (
    <div className="flex gap-4 items-center mb-4">
      <Logo logo={logo} verified_source_type={incomeSourceType} />
      <div>
        <h2 className="text-base text-content-1000 font-medium mb-1">
          {isVerificationSkipped
            ? "Income verification was not available"
            : getVerificationTitleName(income)}
        </h2>
        <p className="text-sm text-content-400">
          {isVerificationSkipped
            ? "—"
            : verificationSourceType[incomeSourceType || ""] ||
              incomeSourceType}
        </p>
      </div>
    </div>
  );
};
